import Joi from "joi";
import PropTypes from "prop-types";

import Form from "../../common/form";
import toastService from "../../../services/toastService";

import { getAffirmativeOptions } from "../../../utils/data";

class PDOAnomalyForm extends Form {
    state: any = {
		data: { hasAnomalies: '' },
		errors: {},
		loading: false,
		touched: false,
		progress: 0,
	};

	static propTypes = {
		hasAnomalies: PropTypes.string,
        onSave: PropTypes.func,
	};

	schema = {
		hasAnomalies: Joi.string().required().label('Has Anomalies'),
	};

	componentDidMount() {
		if (this.props.hasAnomalies) {
			this.setState({ data: { hasAnomalies: this.props.hasAnomalies }});
		}
	}

	doSubmit = () => {
		this.props.onSave(this.state.data.hasAnomalies);
		toastService.success('Saved successfully!');
	};

    render() { 
        return ( 
            <form onSubmit={this.handleSubmit} className="p-2 bg-light border rounded">
                {this.renderSelect({
                    options: getAffirmativeOptions(),
                    name: 'hasAnomalies',
                    label: 'Has Anomalies',
                    placeholder: 'Select Option'
                })}

                <div className="mt-4 mb-2 divider"></div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Save')}
				</div>
            </form>
         );
    }
}
 
export default PDOAnomalyForm;